<template>
  <modal
    :title="`${preset.label} Installation`"
    :body-style="{padding: 0}"
    ref="modal"
  >
    <div class="bg-grey-1 q-pa-lg">
      <q-card class="q-mt-lg">
        <q-card-section>
          <h2 class="text-h6 q-mb-md q-mt-none">
            <q-icon name="fa fa-plus" class="on-left" />
            <span class="text-weight-regular">Step 1:</span> Add Private Footprint to Litify
          </h2>
          <div class="text-body1">
            When you click the button below, you will be redirected to Salesforce
            and prompted to install the Private Footprint application into your organization.
          </div>
          <q-btn
            icon="fa fa-plus"
            label="Add Private Footprint to Litify"
            rounded
            class="full-width q-mt-lg"
          />
        </q-card-section>
      </q-card>
      <q-card class="q-mt-lg">
        <q-card-section>
          <h2 class="text-h6 q-mb-md q-mt-none">
            <q-icon name="fa fa-cog" class="on-left" />
            <span class="text-weight-regular">Step 2:</span> Configure Litify
          </h2>
          <CreateServiceAccount
            :account-id="accountId"
            :integration-type="preset.type"
            @created="serviceAccount = $event"
          />
          <ApiKey v-if="serviceAccount && serviceAccount.apiKey" :value="serviceAccount.apiKey" />
          <MaskedApiKey v-else-if="serviceAccount" v-model:service-account="serviceAccount" />
        </q-card-section>
      </q-card>
      <q-card class="q-mt-lg">
        <q-card-section>
          <h2 class="text-h6 q-mb-md q-mt-none">
            <q-icon name="fa fa-lock" class="on-left" />
            <span class="text-weight-regular">Step 3:</span> Grant Access to Salesforce
          </h2>
          <div class="text-body1">
            When you click the button below, you will be redirected to Salesforce
            and prompted to grant Private Footprint access to your Salesforce account.
          </div>
          <AddProfile
            v-if="serviceAccount"
            type="salesforce_user"
            :account-id="accountId"
            @added="onProfileAdded"
            class="q-mt-lg"
          />
        </q-card-section>
      </q-card>
    </div>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import Modal from '@/components/modal/Modal.vue';
import { IntegrationPreset, ServiceAccount } from '@/iam/types';
import AddProfile from '@/iam/external/profile/AddProfile.vue';
import notify from '@/components/notify';
import { Profile } from '@/iam/external/types';
import MaskedApiKey from '@/iam/integration/service-account/MaskedApiKey.vue';
import CreateServiceAccount from './CreateServiceAccount.vue';
import ApiKey from '../service-account/ApiKey.vue';
import { create as createConnection } from '../connection';

interface Data {
  serviceAccount: ServiceAccount|null,
}

export default defineComponent({
  emits: ['ok'],
  mixins: [ModalMixin],
  components: {
    MaskedApiKey,
    AddProfile,
    ApiKey,
    CreateServiceAccount,
    Modal,
  },
  props: {
    accountId: {
      type: Number,
      required: true,
    },
    preset: {
      type: Object as () => IntegrationPreset,
      required: true,
    },
  },
  data(): Data {
    return {
      serviceAccount: null,
    };
  },
  methods: {
    onProfileAdded(profile: Profile): void {
      if (!this.serviceAccount) return;
      createConnection({
        serviceAccountId: this.serviceAccount.id,
        profileId: profile.id,
      }).then((connection) => {
        notify(`${connection.serviceAccount.label} installed.`);
        this.$emit('ok', connection);
        this.hide();
      });
    },
  },
});
</script>
